import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useMeQueryKey } from './useMeQueryKey'

const document = graphql(`
  query UseMeQuery_Main {
    me {
      id
      isCoreMember
    }
  }
`)

export const useMeQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useMeQueryKey()

  return useQuery({
    queryKey,
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return result.me ?? undefined
    },
    // meの情報が変わることはほぼ無い & 仮に変わるようなことがあったらリロードするはずなので、キャッシュを永続化してしまう
    staleTime: Infinity,
  })
}

export type Me = NonNullable<ReturnType<typeof useMeQuery>['data']>
